import React, {useContext} from 'react';
import Button from "@mui/material/Button";
import UserContext from "../../UserContext"
import * as Colors from "@mui/material/colors";


export default function ArgoExpandCollapseButtonHook(props) {

    const theme = useContext(UserContext); // From blueTheme.js

    const fileName = props.fileName ?? "NoFileName";
    const fieldName = props.fieldName ?? "expand-or-collapse-all";

    const uniqueIdentifier = fileName + "-ArgoButtonHook-" + fieldName;

    const variant = props.variant ?? "contained";

    const label = props.expandAll ? "Expand All" : "Collapse All";

    const paddingTop = props.paddingTop ?? "0px";

    const width = props.width ?? 140;

    const fullWidth = props.fullWidth === undefined ? ((width === 0)) : false;

    const disabled = props.disabled?? false;

    const autofocus = props.autofocus ?? false;

    const onClick = props.onClick ?? function () {};

    // button variant = contained ----------------------------------------------------------------------------------------------------------------

    const containedTextColor = props.containedTextColor ?? "white";
    const containedBgColor = props.containedBgColor ?? Colors.blue[500];

    const containedHoverTextColor = props.containedHoverTextColor ?? "#010203";
    const containedHoverBgColor = props.containedHoverBgColor ?? Colors.blue[500];

    const handleOnClick = (event) => {
        onClick(event, props.fieldName)
    };

    return (
        <div style={{paddingTop: paddingTop}}>
            <Button
                id={uniqueIdentifier}
                name={uniqueIdentifier}
                variant={variant}
                sx={{
                    color: containedTextColor,
                    backgroundColor: containedBgColor,
                    fontFamily: theme.fontFamily,
                    width: width,
                    "&:hover": {
                        color: containedHoverTextColor,
                        backgroundColor: containedHoverBgColor,
                    }
                }}
                onClick={handleOnClick}
                disabled={disabled}
                fullWidth={fullWidth}
                autoFocus={autofocus}
            >
                {label}
            </Button>
        </div>
    );
}
